import React, { Fragment, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import {
  authHeader,
  authfileHeader,
} from "../../../utils/functions/CoreFunctions";
import {
  USER_DETAILS_URL,
  ADMIN_USERS_UPDATE_URL,
  FILE_UPLOAD_URL,
} from "../../../utils/APIEndpoints";
import API from "../../../redux/actions/API";
import {
  getAlertToast,
  getCurrentUserId,
  SingleStringFirstLetterCaps,
} from "../../../utils/functions/CustomFunctions";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  ONLY_STRING,
  TEN_DIGIT_PHONE_NUMBER_REGEX,
} from "../../../utils/constants/ValidationRegexs";
import defaultAvatar from "../../../assets/images/defaultImages/defaultAvatar.png";
import { LOCALSTORAGE_AUTH_USER } from "../../../utils/constants/LocalStorage";
import CustomLoader from "../../common/CustomLoader";

//Validation Schema
const validationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(ONLY_STRING, "Only letters allowed"),
  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(ONLY_STRING, "Only letters allowed"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .email("Enter valid email"),
  phoneNumber: Yup.string()
    .trim()
    .required("Phone number is required")
    .matches(TEN_DIGIT_PHONE_NUMBER_REGEX, "Enter valid phone number"),
  address: Yup.string().trim().required("Address is required"),
});

const Profile = (props) => {
  const [adminData, setAdminData] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [image, setImage] = useState();

  const handleUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    const options = {
      method: "POST",
      url: FILE_UPLOAD_URL,
      headers: authfileHeader(),
      data: formData,
    };
    try {
      Swal.fire(getAlertToast("success", "Please wait..."));
      var apiResponse = await API(options);
      const { status, filepath } = apiResponse.data;
      if (status === "Success") {
        setImage(filepath);
      }
    } catch (error) {
      if (error.response) {
        Swal.fire(
          getAlertToast("error", "File upload failed, please try again!")
        );
      }
    }
  };

  //On Submit
  const saveFormValues = async (values) => {
    // setButtonLoading(true);
    values.createdBy = getCurrentUserId();
    values.profileImage = image;
    const options = {
      method: "PUT",
      url: ADMIN_USERS_UPDATE_URL,
      headers: authHeader(),
      data: values,
    };
    try {
      setBtnLoading(true);
      let response = await API(options);
      const { status, message } = response.data;
      if (status === "Error") {
        Swal.fire(getAlertToast("error", message));
      } else {
        Swal.fire(getAlertToast("success", "Admin updated successfully"));
        let loggedUserData = {
          userId: adminData.userId,
          role: adminData.role,
          agencyId: adminData.agencyId,
          firstName: values.firstName,
          lastName: values.lastName,
          profileImage: values.profileImage,
        };
        localStorage.setItem(
          LOCALSTORAGE_AUTH_USER,
          JSON.stringify(loggedUserData)
        );
        getAdminData();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setBtnLoading(false);
    }
  };

  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    setFieldTouched,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: {
      ...adminData,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });

  //Get Dashboard Data
  const getAdminData = async () => {
    setLoading(true);
    const options = {
      method: "GET",
      url: USER_DETAILS_URL,
      headers: authHeader(),
      params: { userId: getCurrentUserId() },
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      console.log("helllokkk", response.data);
      if (status === "Success") {
        setAdminData(response.data);
        setImage(response.data.profileImage);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Did Mount
  useEffect(() => {
    getAdminData();
  }, []);

  return (
    <Fragment>
      <Row>
        <Col md="5" xs="5">
          <Card body>
            <center>{loading && <CustomLoader loading={loading} />}</center>
            <div className="manageUsertag">
              <img
                className="manageUserImg"
                src={adminData.profileImage || defaultAvatar}
              />
              <h4>
                {adminData.firstName} {adminData.lastName}
              </h4>
              <p>Paygov Admin</p>
            </div>

            <div className="kt-widget__content">
              <div className="kt-widget__info">
                <span className="kt-widget__label">Email:</span>
                <a href="#" className="kt-widget__data">
                  {adminData.email}
                </a>
              </div>
              <div className="kt-widget__info">
                <span className="kt-widget__label">Phone Number:</span>
                <a href="#" className="kt-widget__data">
                  (+1) {adminData.phoneNumber}
                </a>
              </div>
              <div className="kt-widget__info">
                <span className="kt-widget__label">Address:</span>
                <span className="kt-widget__data">{adminData.address}</span>
              </div>
            </div>
          </Card>
        </Col>
        <Col md="7" xs="7">
          <Card className="manageUpdate">
            <CardHeader>
              Personal Information <span>Update your personal information</span>{" "}
            </CardHeader>
            <CardBody>
              <center>{loading && <CustomLoader loading={loading} />}</center>
              <Form onSubmit={handleSubmit}>
                <h6 className="mb-4">Basic Info:</h6>

                <FormGroup row>
                  <Label for="exampleEmail" sm={3}>
                    Profile
                  </Label>
                  <Col sm={9}>
                    <img className="uploadImg" src={image || defaultAvatar} />

                    <label
                      style={{ marginBottom: "0" }}
                      className="btn-bs-file btn btn-lg btn-danger admin-pro-camera"
                    >
                      <i className="fas fa-camera"></i>
                      <Input type="file" onChange={handleUpload} />{" "}
                    </label>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="firstName" sm={3}>
                    First Name
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      invalid={
                        errors.firstName && touched.firstName ? true : false
                      }
                      onChange={({ target: { value } }) => {
                        setFieldTouched("firstName", true);
                        setFieldValue(
                          "firstName",
                          SingleStringFirstLetterCaps(value)
                        );
                      }}
                      value={values.firstName}
                    />
                    <FormFeedback>
                      {errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="lastName" sm={3}>
                    Last Name
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="lastName"
                      id="lastName"
                      placeholder="Last Name"
                      invalid={
                        errors.lastName && touched.lastName ? true : false
                      }
                      onChange={({ target: { value } }) => {
                        setFieldTouched("lastName", true);
                        setFieldValue(
                          "lastName",
                          SingleStringFirstLetterCaps(value)
                        );
                      }}
                      value={values.lastName}
                    />
                    <FormFeedback>
                      {errors.lastName && touched.lastName
                        ? errors.lastName
                        : ""}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <h6 className="mb-4">Contact Info:</h6>

                <FormGroup row>
                  <Label for="phone" sm={3}>
                    Contact Phone
                  </Label>
                  <Col sm={9}>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>+1</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        placeholder="Phone Number"
                        invalid={
                          errors.phoneNumber && touched.phoneNumber
                            ? true
                            : false
                        }
                        onChange={({ target: { value } }) => {
                          setFieldTouched("phoneNumber", true);
                          setFieldValue(
                            "phoneNumber",
                            SingleStringFirstLetterCaps(value)
                          );
                        }}
                        value={values.phoneNumber}
                      />
                      <FormFeedback>
                        {errors.phoneNumber && touched.phoneNumber
                          ? errors.phoneNumber
                          : ""}
                      </FormFeedback>
                    </InputGroup>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="email" sm={3}>
                    Contact Email
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email"
                      invalid={errors.email && touched.email ? true : false}
                      onChange={({ target: { value } }) => {
                        setFieldTouched("email", true);
                        setFieldValue(
                          "email",
                          SingleStringFirstLetterCaps(value)
                        );
                      }}
                      value={values.email}
                      disabled
                    />
                    <FormFeedback>
                      {errors.email && touched.email ? errors.email : ""}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="address" sm={3}>
                    Address
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="textarea"
                      name="address"
                      id="address"
                      placeholder="Address"
                      invalid={errors.address && touched.address ? true : false}
                      onChange={({ target: { value } }) => {
                        setFieldTouched("address", true);
                        setFieldValue(
                          "address",
                          SingleStringFirstLetterCaps(value)
                        );
                      }}
                      value={values.address}
                    />
                    <FormFeedback>
                      {errors.address && touched.address ? errors.address : ""}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <FormGroup check row>
                  <Col sm={{ size: 9, offset: 3 }}>
                    <Button type="submit" color="primary">
                      {btnLoading && <CustomLoader loading={btnLoading} />}{" "}
                      Update
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Profile;
